module.exports = __webpack_public_path__ + "static/web3-6679cffc8caebac0b9155aa9a9a0e349.png";